import type { AttendanceDashboardItem } from '@src/models/interfaces/attendanceDashboard.interface';
import { DateUtil } from '@src/packages/utils/dates';

import type { MarkAttendanceJourneyDetails } from '../types';

const secondsOrNull = (value: AttendanceDashboardItem['actualStartAt']): number | null => {
  const ms = DateUtil.getTimestampMs(value);
  return ms == null ? null : Math.floor(ms / 1000);
};

export const toMarkAttendanceJourneyDetailsFromDashboard = (
  item: AttendanceDashboardItem,
): MarkAttendanceJourneyDetails => ({
  attendanceRecordId: item.id || null,
  scheduledStartAtSeconds: secondsOrNull(item.scheduledStartAt),
  scheduledEndAtSeconds: secondsOrNull(item.scheduledEndAt),
  scheduledBreakStartAtSeconds: secondsOrNull(item.scheduledBreakStartAt),
  scheduledBreakEndAtSeconds: secondsOrNull(item.scheduledBreakEndAt),
  locationLabel: item.locationLabel,
  actualStartAtSeconds: secondsOrNull(item.actualStartAt),
  actualBreakStartAtSeconds: null,
  actualBreakEndAtSeconds: null,
  workJourneyConfigId: item.workJourneyConfigId,
  journeyName: item.journeyName,
  workShiftId: item.workShiftId,
  shiftName: item.regulationName,
});
